import React, { useContext } from "react";
import { LangCtx } from "../../../lib/context";
import { Link, useLocation } from "react-router-dom";

import "../Styles.css";

const WebAdminSideNavLinks = (props) =>
{
  const location = useLocation();
  const { l } = useContext(LangCtx);

  return (
    <>
      <ul className="flexMinHeightCol overFlowY">
        <li className="wsnItem">
          <Link
            to="/dashboard"
            onClick={props.hideMenu}
            className={
              location.pathname === "/dashboard"
                ? "wsnLink wsnAcitve"
                : "wsnLink"
            }
          >
            <img
              src="/images/icons/dashboard.png"
              className="linkIcon invertWhite"
              alt="icon"
            />
            <div className="linkTxtBlock">
              <span>{l.dashboard}</span>
            </div>
          </Link>
        </li>
        <li className="wsnItem">
          <Link
            to="/admin-createusers"
            onClick={props.hideMenu}
            className={
              location.pathname === "/admin-createusers"
                ? "wsnLink wsnAcitve"
                : "wsnLink"
            }
          >
            <img
              src="/images/icons/create-patient-outlined.png"
              className="linkIcon invertWhite"
              alt="icon"
            />
            <div className="linkTxtBlock">
              <span>{l.dashboard_create_user}</span>
            </div>
          </Link>
        </li>
        <li className="wsnItem">
          <Link
            to="/admin-users"
            onClick={props.hideMenu}
            className={
              location.pathname === "/admin-users"
                ? "wsnLink wsnAcitve"
                : "wsnLink"
            }
          >
            <img
              src="/images/icons/group-outlined.png"
              className="linkIcon invertWhite"
              alt="icon"
            />
            <div className="linkTxtBlock">
              <span>{l.dashboard_users}</span>
            </div>
          </Link>
        </li>
        <li className="wsnItem">
          <Link
            to="/configurations"
            onClick={props.hideMenu}
            className={
              location.pathname === "/configurations"
                ? "wsnLink wsnAcitve"
                : "wsnLink"
            }
          >
            <img
              src="/images/icons/gear.png"
              className="linkIcon invertWhite"
              alt="icon"
            />
            <div className="linkTxtBlock">
              <span>{l.dashboard_configuration}</span>
            </div>
          </Link>
        </li>
        {/* <li className="wsnItem">
                    <Link to="/admin-advice" onClick={props.hideMenu} className={location.pathname === "/admin-advice" ? "wsnLink wsnAcitve" : "wsnLink"}>
                        <img src="/images/icons/settings-outline.png" className="linkIcon invertWhite" alt="icon" />
                        <div className="linkTxtBlock"><span>Advice</span></div>
                    </Link>
                </li> */}
        <li className="wsnItem">
          <Link
            to="/my-profile"
            onClick={props.hideMenu}
            className={
              location.pathname === "/my-profile"
                ? "wsnLink wsnAcitve"
                : "wsnLink"
            }
          >
            <img
              src="/images/icons/myprofile.png"
              className="linkIcon invertWhite"
              alt="icon"
            />
            <div className="linkTxtBlock">
              <span>{l.my_profile}</span>
            </div>
          </Link>
        </li>
        {/* <li className="wsnItem">
                    <Link to="/admin-config" onClick={props.hideMenu} className={location.pathname === "/admin-config" ? "wsnLink wsnAcitve" : "wsnLink"}>
                        <img src="/images/icons/analytics.png" className="linkIcon invertWhite" alt="icon" />
                        <div className="linkTxtBlock"><span>Configuration</span></div>
                    </Link>
                </li> */}
        <li className="wsnItem">
          <Link
            to="/admin-settings"
            onClick={props.hideMenu}
            className={
              location.pathname === "/admin-settings"
                ? "wsnLink wsnAcitve"
                : "wsnLink"
            }
          >
            <img
              src="/images/icons/settings-outline.png"
              className="linkIcon invertWhite"
              alt="icon"
            />
            <div className="linkTxtBlock">
              <span>{l.settings}</span>
            </div>
          </Link>
        </li>
        <li className="wsnItem">
          <a className='wsnLink' href="https://help.instavc.com/inconsult" target="_blank">
            <img src='/images/icons/play-button.png' alt='help' className='linkIcon invertWhite' />
            <div className="linkTxtBlock">
              <span>{l.help_center}</span>
            </div>
          </a>
        </li>
      </ul>
      <ul className=" flexAutoCol btmGrp">
        <li className="wsnItem">
          <Link
            onClick={props.handleLogout}
            className={
              location.pathname === "/" ? "wsnLink wsnAcitve" : "wsnLink"
            }
          >
            <img
              src="/images/icons/logout-outline.png"
              className="linkIcon invertWhite"
              alt="icon"
            />
            <div className="linkTxtBlock">
              <span>{l.logout}</span>
            </div>
          </Link>
        </li>
      </ul>
    </>
  );
};

export default WebAdminSideNavLinks;